import { StateCreator } from 'zustand';

import { FileImage } from '@/common/constants';
import { storeCreator } from '@/utils/store/store.utils';

const DEFAULT_STORE_KEY = 'useFilesInDocumentStore';

interface StateValues {
  documentId: string;
  files: FileImage[];
}

interface State {
  values: StateValues;
  handleSetValues: (value: Partial<StateValues>) => void;
  handleReset: () => void;
}

const DEFAULT_VALUES: StateValues = {
  documentId: '',
  files: [],
};

const createDocumentStore = (key: string) => {
  const store: StateCreator<State> = (set) => ({
    values: { ...DEFAULT_VALUES, key },
    handleSetValues: (value: Partial<StateValues>) =>
      set((state) => ({
        ...state,
        values: {
          ...state.values,
          ...value,
        },
      })),
    handleReset: () =>
      set((state) => ({
        ...state,
        values: DEFAULT_VALUES,
      })),
  });

  return storeCreator<State>(store);
};

const storeCache: { [key: string]: ReturnType<typeof createDocumentStore> } = {};
 const useFilesInDocumentStore = (key = DEFAULT_STORE_KEY) => {
  if (!storeCache[key]) {
    storeCache[key] = createDocumentStore(key);
  }
  return storeCache[key]();
};

export const clearFilesInDocumentStore = (key = DEFAULT_STORE_KEY) => {
  delete storeCache[key];
};

export default useFilesInDocumentStore;

